export default __webpack_public_path__ + "static/media/banner.240be602.jpeg";